import { useEffect, useState } from 'react';
import { Layout, Drawer } from 'antd';
import TenantAwareOutlet from '../components/layout/TenantAwareOutlet';
import AnnouncementPopup from '../pages/Announcements/AnnouncementPopup';
import ActionItemReminderPopup from '../pages/ActionItems/components/ActionItemReminderPopup';
import OrgRouteGuard from '../components/layout/OrgRouteGuard';

import Sidebar from '../components/layout/Sidebar';
import Header from '../components/layout/Header';
import PanelBreadcrumbs from '../components/layout/PanelBreadcrumbs';
import ImpersonationBanner from '../components/layout/ImpersonationBanner';
import OrgPackageBanner from '../components/org/OrgPackageBanner';
import LiveAudioRecorderBootstrap from '../components/LiveAudioRecorderBootstrap';
import { useIsMobile } from '../hooks/useMediaQuery';
import { useLocalStorage } from '../hooks/useLocalStorage';
import { STORAGE_KEYS } from '../config/app.config';
import { BreadcrumbTitleProvider } from '../contexts/BreadcrumbTitleContext';

const { Content } = Layout;

/**
 * Layout اصلی پنل که شامل Sidebar، Header و Content است.
 * در حالت موبایل، Sidebar داخل Drawer نمایش داده می‌شود.
 */
const MainLayout = () => {
  const isMobile = useIsMobile();
  const [collapsed, setCollapsed] = useLocalStorage(STORAGE_KEYS.COLLAPSED, false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    if (isMobile) setMobileOpen(false);
  }, [isMobile]);

  const handleToggle = () => {
    if (isMobile) {
      setMobileOpen((v) => !v);
    } else {
      setCollapsed((v) => !v);
    }
  };

  return (
    <BreadcrumbTitleProvider>
      <Layout className="min-h-screen" hasSider>
        <LiveAudioRecorderBootstrap />
        <AnnouncementPopup />
        <ActionItemReminderPopup />
        {!isMobile && (
          <Sidebar collapsed={collapsed} onToggle={handleToggle} isMobile={false} />
        )}

        {isMobile && (
          <Drawer
            placement="right"
            open={mobileOpen}
            onClose={() => setMobileOpen(false)}
            width={272}
            closable={false}
            styles={{
              body: { padding: 0, height: '100%' },
              header: { display: 'none' },
              mask: { backdropFilter: 'blur(4px)' },
            }}
            rootClassName="md:!hidden"
          >
            <Sidebar collapsed={false} onToggle={() => setMobileOpen(false)} isMobile />
          </Drawer>
        )}

        <Layout className="app-shell !min-w-0 min-h-screen !bg-[var(--color-bg)]">
          <ImpersonationBanner />
          <OrgRouteGuard />
          <Header onToggleSidebar={handleToggle} isMobile={isMobile} />
          <OrgPackageBanner />

          <Content className="px-3 py-2 sm:px-4 sm:py-2.5 lg:px-5 lg:py-3">
            <div className="mx-auto w-full max-w-[1600px] app-fade-in">
              <PanelBreadcrumbs />
              <TenantAwareOutlet />
            </div>
          </Content>
        </Layout>
      </Layout>
    </BreadcrumbTitleProvider>
  );
};

export default MainLayout;
